export interface CloudGpxType {
    prefix: string;
    isPublic: boolean;
    name: string;
}

const CloudGpxTypes = [
    {prefix: "r", name: "Private", isPublic: false},
    {prefix: "u", name: "Public", isPublic: true}
] as CloudGpxType[]
export default CloudGpxTypes